// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1UNYp","img":"Item_img___WEOa","icon":"Item_icon__39Dv3","subtitle":"Item_subtitle__8wNvi","tooltip":"Item_tooltip__ibofE","counter":"Item_counter__2y4T1"};